import axios from 'axios';
import AuthService from "./AuthService";
import HandleRequestError from "./HandleRequestError";
import {Navigate } from "react-router-dom";
import React from "react";
import Swal from "sweetalert2"; // Importando o JS do Bootstrap

class ApiService {

    static async send(method, url, data, includeHeaders = true, responseType = 'json') {
        try {
           let config = {
               responseType: responseType, // Define o tipo de resposta
               headers: {} // Inicializa headers
           };

           // Inclui headers se necessário
           if (includeHeaders) {
               if (AuthService.isTokenExpired()) {
                   AuthService.logout()
                   window.location.reload();
                   return false;
               }
               const token = AuthService.getToken();
               config.headers = {
                   'Authorization': `Bearer ${token}`,
                   'Content-Type': 'application/json',
                                  };
           } else if (AuthService.isAuthenticated()) {
               const token = AuthService.getToken();
               config.headers = {
                   'Authorization': `Bearer ${token}`,
                   'Content-Type': 'application/json',
                                  };
           }

           // Configura parâmetros para GET ou dados para outros métodos
           if (data) {
               if (method.toLowerCase() === 'get') {
                   config.params = data;
               } else {
                   config.data = data;
               }
           }

          return await axios({
               method: method,
               url: url,
               ...config,
           });
        } catch (error) {
            throw error;
        }

    }


    static async sendArquivo(method, url, data, includeHeaders = true) {
        try {
            let config = {
                headers: {}
            };

            if (includeHeaders) {
                if (AuthService.isTokenExpired()) {
                    const tokenRefreshed = await AuthService.refreshToken();
                    if (!tokenRefreshed) {
                        // Lidar com redirecionamento fora desta função
                        return {error: "Token Expirado"};
                    }
                }
                const token = AuthService.getToken();
                config.headers = {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                                    };
            }

            const response = await axios({
                method: method,
                url: url,
                data: data,
                ...config
            });

            return response;

        } catch (error) {
            console.error("Erro na requisição de arquivo:", error);
            throw error;
        }
    }


    static handleApiResponse(response) {

        if (!response || (response?.code !== 200 && response?.code !== 201 ) ) {
            throw new Error(response?.message || "Erro desconhecido na resposta.");
        }

        const responseData = response?.data || {};

        if(!responseData?.data){

            return {
                data: responseData || []
            };
        }


        const responseExtras = responseData?.extras || {};
        const pagination = responseData?.pagination || {};

        const paginationInfo = {
            current: pagination?.current_page || 1,
            total: pagination?.total || 0,
            pageSize: pagination?.per_page || 10,
            lastPage: pagination?.last_page || 1,
        };



        return {
            extras: responseExtras || [],
            data: responseData?.data || [],
            pagination: paginationInfo,
        };
    }


    // Método global para tratar erros de requisição
    static handleApiError(error) {


        if (error.response) {
            const responseData = error.response?.data || {};
            const message = responseData?.data?.message || responseData?.message || 'Erro desconhecido';
            const errors = responseData?.data?.errors || responseData?.errors || [];

            let errorMessage = message;

            if (Array.isArray(errors) && errors.length > 0) {
                errorMessage = errors.map(err => `<li>${err}</li>`).join('');
                errorMessage = `<ul style="list-style-type: none; padding-left: 0; margin: 0;">${errorMessage}</ul>`; // Lista HTML formatada sem bullets
            }

            Swal.fire({
                title: 'Erro!',
                html: errorMessage || message,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } else {
            Swal.fire({
                title: 'Erro!',
                text: 'Erro ao processar a requisição',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    }

    static handleApiMessage(response) {
        if (response) {
            const responseData = response?.data || {};
            const mainMessage = responseData?.message || 'Sucesso!';
            const subMessage = responseData?.data?.message || null;

            const finalMessage = subMessage || mainMessage;

            Swal.fire({
                title: 'Sucesso!',
                text: finalMessage,
                icon: 'success',
                confirmButtonText: 'OK'
            });
        } else {
            Swal.fire({
                title: 'Sucesso!',
                text: 'Operação realizada com sucesso.',
                icon: 'success',
                confirmButtonText: 'OK'
            });
        }
    }



}

export default ApiService;